import { toast } from "sonner";

/**
 * Save an image (URL) to the phone's Photos / Camera Roll via the Web Share API.
 * Falls back to a JPEG download on desktop / older browsers.
 *
 *  await saveImageToPhotos(url, "menu.jpg", "When Pigs Fly Menu");
 */
export async function saveImageToPhotos(src, filename = "wpf.jpg", shareTitle = "When Pigs Fly BBQ") {
  const res = await fetch(src);
  const blob = await res.blob();

  // Re-encode to JPEG so iOS Photos / iCloud actually accept it (webp/png sometimes fail)
  const jpegBlob = await new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("blob failed"))), "image/jpeg", 0.92);
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(blob);
  });

  const file = new File([jpegBlob], filename, { type: "image/jpeg" });

  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: shareTitle });
      return "shared";
    } catch (err) {
      if (err && err.name === "AbortError") return "cancelled";
      // fall through to download fallback
    }
  }

  const url = URL.createObjectURL(jpegBlob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  toast.success("Saved. On iPhone: open the file and long-press to Save to Photos.");
  return "downloaded";
}
